module.exports = __webpack_public_path__ + "d764bedf7ad2e2335a4d3c65b810a2f1.pdf";